// extracted by mini-css-extract-plugin
module.exports = {"content":"product-detail-container_content__8EfwI"};